<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <UsersForm :baseUser="user" :baseUserName="name" :loading="loading" @submit-requested="submitRequested"></UsersForm>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import UsersForm from './UsersForm.vue'
import router from '@/router';

export default {
    data() {
        return {
            user: null,
            name: this.$route.params.name,
            loading: true
        }
    },
    components: { UsersForm },
    computed:
    {
        ...mapState('users', ['getUserByIdOutput']),
    },
    methods: {
        ...mapActions('users', ['getUserById']),
        ...mapActions('users', ['putUser']),
        submitRequested(user) {
            this.putUser({...user, id: this.$route.query.id});
        },
    },
    mounted: function () {
        if (!this.$route.query.id) {
            router.push({ name: 'UsersList' });
        }

        this.getUserById(this.$route.query.id);
    },
    watch:
    {
        getUserByIdOutput: function(userOutput)
        {
            if(!userOutput && !userOutput.data)
            {
                router.push({ name: 'UsersList' });
            }
            else
            {
                this.user = userOutput.data;
                this.loading = false;
            }
        }
    }
}
</script>